'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { StarRating } from '../StarRating';
import { Text } from '../Text';
import { Avatar } from '../../core-components/Avatar';
import { StoreBlockContext } from './StoreBlockContext';
import { separateChildrenByType } from '../../util';
const StyledHeading = styled.div.withConfig({
  componentId: "aui__sc-1dkjae5-0"
})(["padding-bottom:var(--aui-spacing-100);display:flex;flex-direction:row;gap:var(--aui-spacing-100);[data-aui='avatar']{margin-top:", ";}"], ({
  $size
}) => ({
  sm: '6px',
  lg: '3px',
  xl: '8px'
})[$size]);
const StyledHeadingColumn = styled.div.withConfig({
  componentId: "aui__sc-1dkjae5-1"
})(["display:flex;flex-direction:column;gap:var(--aui-spacing-050);"]);
export const Heading = ({
  storeNumber,
  children,
  ...props
}) => {
  const {
    size
  } = useContext(StoreBlockContext);
  const textSize = {
    sm: 4,
    lg: 5,
    xl: 6
  }[size];
  const textLineHeight = {
    sm: 1.3,
    md: 1.2,
    lg: 1.15
  }[size];
  const avatarSize = {
    sm: 'sm',
    lg: 'lg',
    xl: 'lg'
  }[size];
  const [starRating, otherChildren] = separateChildrenByType(children, StarRating);
  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    $size: size
  }, props), storeNumber && /*#__PURE__*/React.createElement(Avatar, {
    size: avatarSize
  }, storeNumber), /*#__PURE__*/React.createElement(StyledHeadingColumn, null, /*#__PURE__*/React.createElement(Text, {
    weight: "heavy",
    size: textSize,
    lineHeight: textLineHeight
  }, otherChildren), starRating));
};